/* Special characters */
export const CRON_EVERY = "*";
export const CRON_LIST_SEPARATOR = ",";
export const CRON_RANGE_SEPARATOR = "-";
export const CRON_START_OR_BLANK = "?";
export const CRON_STEPS_SEPARATOR = "/";
export const CRON_SPECIFIC_SEPARATOR = "#";
export const CRON_LAST = "L";

/* Indexes */
export const QUARTZ_SECONDS_POSITION = 0;
export const QUARTZ_MINUTES_POSITION = 1;
export const QUARTZ_HOURS_POSITION = 2;
export const QUARTZ_DAY_OF_MONTH_POSITION = 3;
export const QUARTZ_MONTH_POSITION = 4;
export const QUARTZ_DAY_OF_WEEK_POSITION = 5;
export const QUARTZ_YEAR_POSITION = 6;
export const UNIX_MINUTES_POSITION = 0;
export const UNIX_HOURS_POSITION = 1;
export const UNIX_DAY_OF_MONTH_POSITION = 2;
export const UNIX_MONTH_POSITION = 3;
export const UNIX_DAY_OF_WEEK_POSITION = 4;
